"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Request = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _axios = _interopRequireDefault(require("axios"));

var _logger = require("@/services/logger/logger.service");

var _helper = require("@/services/helper/helper.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var api = 'VUE_APP_API_';
var tmsKey = process.env.VUE_APP_TMS_KEY || 'x-tms-key';

var handleResponse = function handleResponse(response) {
  var boolean = response.status === 200 && response.data && (response.data.status === 200 || response.data.status === 'success');
  /*if (!boolean) {
  const errorMsg = (response && response['data'] && response['data']['message']) ? response['data']['message'] : 'server-error';
  const message: ElNotificationOptions = {
    title: errorMsg,
    duration: 5000
  } as ElNotificationOptions;
   Notification.error(message);
  }*/

  return boolean ? response.data : {
    failed: true,
    message: response.data && response.data.message ? response.data.message : 'server-error',
    data: response.data && response.data.data ? response.data.data : {}
  };
};

var handleResponseFile = function handleResponseFile(res) {
  var status = res.status === 200 && res.data;
  return status ? res.data : {
    status: 'failed',
    message: res.data && res.data.message ? res.data.message : 'server-error',
    data: res.data && res.data.data ? res.data.data : {}
  };
};

var handleError = function handleError(error, type) {
  // const errData = (error && error.response)this.helper.get(error, 'response.data', error);
  // this.logger.error(type, errData);
  return type === 'GET' ? null : {
    failed: true,
    message: error
  };
};

var Request = /*#__PURE__*/function () {
  function Request() {
    var _this = this;

    var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'application/json';
    var auth = arguments.length > 1 ? arguments[1] : undefined;
    var key = arguments.length > 2 ? arguments[2] : undefined;
    (0, _classCallCheck2.default)(this, Request);
    this.logger = new _logger.Logger();
    this.helper = new _helper.Helper();
    var headers = (0, _defineProperty2.default)({
      'Content-Type': contentType
    }, process.env.VUE_APP_SECRET_KEY, auth ? auth : key ? key : process.env.VUE_APP_SECRET_KEY_ENCODED_HASH);
    this.service = _axios.default.create({
      headers: headers
    }); // every endpoint expects the TMS key alongside the customer key - resolved per request so it
    // picks up the token even when the API class was instantiated before the user logged in

    this.service.interceptors.request.use(function (config) {
      var lfToken = _this.getLFToken();

      if (_this.helper.isNotEmpty(lfToken)) {
        config.params = _objectSpread((0, _defineProperty2.default)({}, tmsKey, lfToken), config.params || {});
      }

      return config;
    });
  }

  (0, _createClass2.default)(Request, [{
    key: "getLFToken",
    value: function getLFToken() {
      var cookie = this.helper.getCookie(process.env.VUE_APP_AUTH_COOKIE);
      return cookie ? cookie.split('|')[0] : '';
    }
  }, {
    key: "getFullPath",
    value: function getFullPath() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'core';
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
      var url = process.env["".concat(api).concat(name)];
      return "".concat(url, "/").concat(path);
    }
  }, {
    key: "get",
    value: function get() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'core';
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var isFullPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var url = process.env["".concat(api).concat(name)];
      var fullPath = isFullPath ? path : this.helper.isNotEmpty(path) ? "".concat(url, "/").concat(path) : url;
      return this.service.get(fullPath, {
        params: params
      }).then(function (response) {
        return handleResponse(response);
      }).catch(function (error) {
        return handleError(error, 'GET');
      });
    }
  }, {
    key: "getFile",
    value: function getFile() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'core';
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var isFullPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var url = process.env["".concat(api).concat(name)];
      var fullPath = isFullPath ? path : this.helper.isNotEmpty(path) ? "".concat(url, "/").concat(path) : url;
      return this.service.get(fullPath, {
        params: params,
        responseType: 'blob'
      }, {
        crossDomain: true
      }).then(function (response) {
        return handleResponseFile(response);
      }).catch(function (error) {
        return handleError(error, 'GET');
      });
    }
  }, {
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var promises = [];
      paths.forEach(function (dataval) {
        promises.push(_this2.get('', dataval, null, true));
      });
      return Promise.all(promises).then(function (results) {
        return results;
      }).catch(function (error) {
        var errData = _this2.helper.get(error, 'response.data', error);

        _this2.logger.error('GET ALL', errData);

        return null;
      });
    }
  }, {
    key: "post",
    value: function post() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'core';
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var isFullPath = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var url = process.env["".concat(api).concat(name)];
      var fullPath = isFullPath ? path : this.helper.isNotEmpty(path) ? "".concat(url, "/").concat(path) : url;
      return this.service.request({
        method: 'POST',
        url: fullPath,
        params: params,
        data: data
      }).then(function (response) {
        return handleResponse(response);
      }).catch(function (error) {
        return handleError(error, 'POST');
      });
    }
  }, {
    key: "postFile",
    value: function postFile() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'core';
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var isFullPath = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var isBlob = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var url = process.env["".concat(api).concat(name)];
      var fullPath = isFullPath ? path : this.helper.isNotEmpty(path) ? "".concat(url, "/").concat(path) : url;
      var reqOpts = {
        method: 'POST',
        url: fullPath,
        params: params,
        data: data
      };

      if (isBlob) {
        reqOpts['responseType'] = 'blob';
      }

      return this.service.request(reqOpts, {
        crossDomain: true
      }).then(function (response) {
        return handleResponseFile(response);
      }).catch(function (error) {
        return handleError(error, 'POST');
      });
    }
  }, {
    key: "put",
    value: function put() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'core';
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var isFullPath = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var url = process.env["".concat(api).concat(name)];
      var fullPath = isFullPath ? path : this.helper.isNotEmpty(path) ? "".concat(url, "/").concat(path) : url;
      return this.service.request({
        method: 'PUT',
        url: fullPath,
        params: params,
        data: data
      }).then(function (response) {
        return handleResponse(response);
      }).catch(function (error) {
        return handleError(error, 'PUT');
      });
    }
  }, {
    key: "delete",
    value: function _delete() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'core';
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var isFullPath = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var url = process.env["".concat(api).concat(name)];
      var fullPath = isFullPath ? path : this.helper.isNotEmpty(path) ? "".concat(url, "/").concat(path) : url;
      return this.service.request({
        method: 'DELETE',
        url: fullPath,
        params: params,
        data: data
      }).then(function (response) {
        return handleResponse(response);
      }).catch(function (error) {
        return handleError(error, 'DELETE');
      });
    }
  }]);
  return Request;
}();

exports.Request = Request;